module.exports = __webpack_public_path__ + "static/media/Brown.c3d6dfa4.png";